export const Cookies = {
    stringify: cookies =>
        cookies
            ? Object.entries(cookies)
                .map(cookie => cookie.join('='))
                .join(';')
            : ''
};
